export const COUNSELOR_BRANDS: readonly string[] = ["flow", "etb"];
export const DEFAULT_COUNSELOR_BRAND = "flow";

export function counselorBrandFor(brandId: string): string {
  return COUNSELOR_BRANDS.includes(brandId) ? brandId : DEFAULT_COUNSELOR_BRAND;
}
